import type { useReportingLines } from '@atlassian/teams/use-reporting-lines';

import { type ReportingLines } from './ReportingLines/types';

const hasNoReportingLinesData = ({ user, managers, peers, reports }: ReportingLines) => {
	return (
		!user ||
		!managers ||
		!reports ||
		!peers ||
		(managers.length === 0 && reports.length === 0 && peers.length === 0)
	);
};

export const responseHasReportingLinesData = (
	reportingLinesResponse: ReturnType<typeof useReportingLines>,
): boolean | undefined => {
	return (
		reportingLinesResponse.reportingLines &&
		!reportingLinesResponse.error &&
		!hasNoReportingLinesData(reportingLinesResponse.reportingLines)
	);
};
